import { AxiosError } from "axios";

import { api } from "@/lib/axios";

interface userUpdatePassworParams {
	password: string;
	password_confirmation: string;
}

export async function userUpdatePassword(
	data: userUpdatePassworParams,
	id: string,
): Promise<
	| {
			status: "success";
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.put(`/user/update-password/${id}`, data);

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
